import React, {useState} from 'react';
import styled from "styled-components";
import Sizes from '../Assets/Sizes';
import store, {history, resetWizardToBeginning} from "../Store";
import {Button, Icon} from "rmwc";
import {Link} from "react-router-dom";
import {valueOrDefault} from "@tomeravni/easybizy-js-common/common";


const DEFAULT_EASYBIZY_LOGO = 'https://files.easybizy.net/files/__general/public/images/e_logo_black.png';

const Toolbar = styled.div.attrs({
    className: 'page__toolbar',
})`
    padding-left: ${Sizes.defaultPadding};
    padding-right: ${Sizes.defaultPadding};
    height: ${Sizes.toolbarHeight};
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: ${p => p.theme.colors.customNavigationBarBackgroundColor || p.theme.colors.surfaceFront};
    display: flex;
    justify-content: ${p => p.hideBack ? 'center' : 'space-between'};
    align-items: center;
    ${p => p.theme.colors.customNavigationBarShadow || (!p.invertedColors ? 'box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);' : '')}
`;

const ImageWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${Sizes.toolbarIconHeightSize * 1.4}px;
    width: ${Sizes.toolbarIconHeightSize * 1.4}px;
    border-radius: 50%;
    background: ${p => p.theme.colors.surfaceTop};
    padding: 5px;
    overflow: hidden;
    background-size: 65%;
    background-repeat: no-repeat;
    background-position: center center;

`;

const Image = styled.img`
    height: ${Sizes.toolbarIconHeightSize * 1.4}px;
    width: auto;
`;


const BackBottom = styled.div`
    margin-right: -${Sizes.defaultPadding};
`;

const BackButton = styled(Button).attrs({
    className: 'mdc--transparent',
})`
    --mdc-theme-primary: ${p => p.theme.colors.customNavigationBarColor || p.theme.colors.safeText};
    height: 45px !important;
    min-width: 45px;
`;

const ToolbarWithLogo = (props) => {
    const [error, setError] = useState(false);
    const [image, setImage] = useState(false);

    const reset = () => {
        resetWizardToBeginning()
    };

    if (props.imageUri && props.imageUri !== image) {
        setImage(props.imageUri);
        setError(null);
    }

    return (<Toolbar {...props}>
        {!props.hideBack && <BackBottom>
            <BackButton onClick={() => store.dispatch(history.goBack)}><Icon
                icon={props.ltr ? 'keyboard_arrow_left' : 'keyboard_arrow_right'}/></BackButton>
        </BackBottom>}
        {props.children}
        <Link
            onClick={() => reset()}
            to={{
                pathname: valueOrDefault(props.rootUri, '/'),
                // search: QueryString.stringify({ token, base_url })
            }}>
            <ImageWrapper>
                {(!error && image) && <Image src={image} onError={() => setError(true)}/>}
                {error && <Image src={DEFAULT_EASYBIZY_LOGO}/>}
            </ImageWrapper>
        </Link>
    </Toolbar>);
};


export {
    ToolbarWithLogo
}
